'use strict';

// A list of potentially troublesome currencies that should have resized font-size
// TODO: use in membership buy modal

export default {
  currencyList: ['IDR']
};



// WEBPACK FOOTER //
// ./app/src/services/special_currencies.js